import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=25cb8932"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports